export default function Header() {
  const linkClass =
    "relative px-3 py-2 text-white/80 hover:text-white " +
    // underline animada
    "after:absolute after:left-[0.75rem] after:right-[0.75rem] after:bottom-1 " +
    "after:h-[2px] after:rounded-full after:bg-white/70 after:scale-x-0 " +
    "after:origin-left after:transition-transform after:duration-300 " +
    "hover:after:scale-x-100";
  return (
    <header className="sticky top-0 z-40 bg-black/30 backdrop-blur border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div
            className="h-10 w-10 rounded-xl grid place-items-center"
            style={{ background: "linear-gradient(135deg,#FF0064 0%, #ff4d91 60%)" }}
          >
            {/* Ícone de casa (limpo) */}
            <svg
              viewBox="0 0 24 24"
              className="h-5 w-5 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 21h18" />
              <path d="M4 11L12 4l8 7" />
              <path d="M6 10v10h12V10" />
              <path d="M11 20v-5h2v5" />
              <path d="M16 6v2" />
            </svg>
          </div>
          <div>
            <p className="kicker text-[10px] uppercase text-white/60">by LOViZ</p>
            <p className="font-bold">Condomínios Digitais</p>
          </div>
        </div>
        <nav className="hidden md:flex items-center gap-2 text-sm">
          <a href="#servicos" className={linkClass}>Serviços</a>
          <a href="#como" className={linkClass}>Como funciona</a>
          <a href="#beneficios" className={linkClass}>Benefícios</a>
          <a href="#planos" className={linkClass}>Planos</a>
          <a href="#faq" className={linkClass}>FAQ</a>
          <a href="#cta" className="btn btn-primary ml-2">Agendar visita</a>
        </nav>
      </div>
    </header>
  );
}
